import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useDebugValue, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { viewLink } from '../utils/links';
import { maybeCastToNumber } from '../utils/maybeCastToNumber';
import { VIEW_ID_KEYS } from '../utils/views';
import { useActiveView } from './useActiveView';
import { usePinnedViews } from './usePinnedViews';
import { useQueryParamString } from './useQueryParams';
import { jsx as _jsx } from "react/jsx-runtime";
export function useActiveViewId() {
  const {
    defaultViewId
  } = useDefaultViewId();
  const {
    viewId: viewIdStr
  } = useParams();
  const viewIdParam = maybeCastToNumber(viewIdStr);
  const activeViewId = viewIdParam || defaultViewId || VIEW_ID_KEYS.OPEN_TASKS_ALL;
  useDebugValue(activeViewId);
  return activeViewId;
}
export function useSwitchActiveViewId({
  closeAllPanels = false
} = {}) {
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  const {
    queueId,
    taskId
  } = useParams();
  const queryParamString = useQueryParamString();
  return useCallback(viewId => {
    history.push(`${viewLink({
      closeAllPanels,
      currentPathname: pathname,
      queueId: Number(queueId),
      taskId: Number(taskId),
      viewId
    })}${queryParamString}`);
  }, [closeAllPanels, history, pathname, queueId, taskId, queryParamString]);
}
export function useDefaultViewId() {
  var _pinnedViews$;
  const {
    pinnedViews,
    pinnedViewsLoading
  } = usePinnedViews();
  if (pinnedViewsLoading) return {
    isLoading: true,
    defaultViewId: ''
  };
  return {
    isLoading: false,
    defaultViewId: ((_pinnedViews$ = pinnedViews[0]) === null || _pinnedViews$ === void 0 ? void 0 : _pinnedViews$.id) || VIEW_ID_KEYS.OPEN_TASKS_ALL
  };
}
export function useLoadActiveViewAndRedirectIfNotFound() {
  const {
    pathname
  } = useLocation();
  const {
    queueId,
    taskId
  } = useParams();
  const viewId = useActiveViewId();
  const history = useHistory();
  const viewQ = useActiveView();
  const defaultViewIdPkg = useDefaultViewId();
  const queryParamsString = useQueryParamString();
  const isLoading = viewQ.loading || defaultViewIdPkg.isLoading;
  // if view doesn't exist (deleted or not shared with the current user), redirect
  useEffect(() => {
    if (!isLoading && viewQ.error) {
      // redirect to the default view
      history.replace(`${viewLink({
        currentPathname: pathname,
        viewId: defaultViewIdPkg.defaultViewId,
        queueId: Number(queueId),
        taskId: Number(taskId)
      })}${queryParamsString}`);
      FloatingAlertStore.addAlert({
        type: 'warning',
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'tasksAlerts.invalidView.title'
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tasksAlerts.invalidView.viewMessage"
        })
      });
    }
  }, [defaultViewIdPkg.defaultViewId, history, isLoading, pathname, queueId, queryParamsString, taskId, viewQ.error]);
  return {
    isLoading,
    activeViewId: viewId
  };
}